import { loginSuccess } from "../../login/actions";
import { getUserSuccess } from "../../admin/actions";

const AUTH_DATA = "AUTH_DATA";
const ADMIN_DATA = "ADMIN_DATA";
export const saveAuthData = (authData) => {
  localStorage.setItem(AUTH_DATA, JSON.stringify(authData));
};
export const saveAdminData = (adminData) => {
  localStorage.setItem(ADMIN_DATA, JSON.stringify(adminData));
};
export const restaureAuthData = (store) => {
  const authData = localStorage.getItem(AUTH_DATA);
  const adminDAta = localStorage.getItem(ADMIN_DATA);
  if (authData) {
    store.dispatch(loginSuccess(JSON.parse(authData)));
  }
  if (adminDAta) {
    store.dispatch(getUserSuccess(JSON.stringify(adminDAta)));
  }
};

export const clearAuthData = () => {
  localStorage.removeItem(AUTH_DATA);
  localStorage.removeItem(ADMIN_DATA);
};
export const checkSubcriptionValidity = (subcription) => {
  if (subcription.accountStatus.isSubscriptionExpired) {
    return false;
  }
  return true;
};

export const checkAuthDataValidity = (authData) => {
  const { created } = authData;

  let { ttl } = authData;
  ttl *= 1000;

  const createdDate = Math.round(new Date(created).getTime());
  const expiryDate = createdDate + ttl;

  return Date.now() <= expiryDate;
};



// WEBPACK FOOTER //
// ./src/pages/utils/auth/authData.js